export default function($filter) {
  'ngInject';

  return seconds => {
    return $filter('date')(new Date(0, 0, 0).setSeconds(seconds), 'HH:mm:ss');
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/SecondsToTime.js